import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import CustomerMenu from './Components/customerMenu';
import CustomerWelcome from './Components/customerWelcome';
import CustomerOrders from './Components/customerOrders';
import CustomerWishlist from './Components/customerWishlist';
import MyAddress from './Components/myAddress'; // assuming you have this
import { RootState } from '@/core/redux/store';
import { useSearchParams } from 'react-router';
import { Link } from 'react-router';
import OrderDetails from './orderDetails';
import AccountDetails from './Components/AccountDetails';
import NeedHelp from './Components/needHelp';
import MyReferrals from './Components/MyReferrals';

const CustomerDashboard = () => {
  const [orderId, setOrderId] = useState<number | null>(null);
  const [searchParams] = useSearchParams();
  const activeTab = useSelector(
    (state: RootState) => state.common.activeCustomerTab
  );

  useEffect(() => {
    // Check for order ID in URL search params
    const orderIdParam = searchParams.get('orderId');
    if (orderIdParam) {
      setOrderId(parseInt(orderIdParam));
    }
  }, [searchParams]);

  const renderContent = () => {
    switch (activeTab) {
      case 'orders':
        return <CustomerOrders setOrderId={setOrderId} />;
      case 'orderDetails':
        return <OrderDetails orderId={orderId} />;
      case 'wishlist':
        return <CustomerWishlist />;
      case 'address':
        return <MyAddress />;
      case 'my-referrals':
        return <MyReferrals />;
      case 'account-details':
        return <AccountDetails />;
      case 'need-help':
        return <NeedHelp />;
      case 'welcome':
      default:
        return <CustomerWelcome />;
    }
  };

  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-section mb-3">
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="page-title">
                {activeTab
                  ?.split('-')
                  ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  ?.join(' ')}
              </h1>
              <ul>
                <li>
                  <Link to={routes.home}>Dashboard</Link>
                </li>
                <li className="active">
                  {activeTab
                    ?.split('-')
                    ?.map(
                      (word) => word.charAt(0).toUpperCase() + word.slice(1)
                    )
                    ?.join(' ')}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div> */}

      {/* Dashboard Layout */}
      <section className="my-account-section mt-4">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="user-sidebar-menu">
                <CustomerMenu />
              </div>
            </div>
            <div className="col-md-9 tabs style1">{renderContent()}</div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CustomerDashboard;
